import React from 'react';
import FrontdeskButton from '$components/FrontdeskButton';
import CheckBox from '$components/CheckBox';
import './EndConsultationComponent.scss';
import {ConsultationOutcomePayload} from '$api/frontdesk';

interface EndConsultationComponentProps {
  bookingId: number;
  user: {id: number; hospitalId?: number};
  patientId: number;
  outcomeForm: {
    description: string;
    surgery_listed: boolean;
    follow_up_required: boolean;
  };
  setOutcomeForm: React.Dispatch<
    React.SetStateAction<{
      description: string;
      surgery_listed: boolean;
      follow_up_required: boolean;
    }>
  >;
  sendConfirmConsultationOutcomeRequest: (
    data: ConsultationOutcomePayload
  ) => void;
  isPending: boolean;
  disableSubmit: boolean;
}

const EndConsultationComponent: React.FC<EndConsultationComponentProps> = ({
  bookingId,
  user,
  patientId,
  outcomeForm,
  setOutcomeForm,
  sendConfirmConsultationOutcomeRequest,
  isPending,
  disableSubmit,
}) => {
  const [showValidation, setShowValidation] = React.useState(false);
  const isDescriptionEmpty = !outcomeForm.description.trim();

  const handleSurgeryListedClick = () => {
    setOutcomeForm(prev => ({
      ...prev,
      surgery_listed: !prev.surgery_listed,
    }));
  };

  const handleFollowUpRequiredClick = () => {
    setOutcomeForm(prev => ({
      ...prev,
      follow_up_required: !prev.follow_up_required,
    }));
  };

  const handleSubmit = () => {
    if (isDescriptionEmpty) {
      setShowValidation(true);
      return;
    }
    if (!bookingId) return;
    sendConfirmConsultationOutcomeRequest({
      outcomes: {
        appointment_id: bookingId,
        patient_id: patientId,
        consultant_id: user?.id || 0,
        hospital_id: user?.hospitalId || 0,
        description: outcomeForm.description,
        surgery_listed: outcomeForm.surgery_listed,
        follow_up_required: outcomeForm.follow_up_required,
      },
    });
  };

  return (
    <div className="end-consultation-container">
      <div className="end-consultation-title">
        <div className="title-text">Consultation outcome</div>
        <div className="title-desc">
          Please specify any further actions required from the front desk staff
          before checking out the patient.
        </div>
      </div>
      <div className="end-consultation-body">
        <div className="input-container">
          <CheckBox
            label={
              <span className="checkbox-label">List patient for surgery</span>
            }
            checked={outcomeForm.surgery_listed}
            onClick={handleSurgeryListedClick}
          />
          <CheckBox
            label={<span className="checkbox-label">Follow-up required</span>}
            checked={outcomeForm.follow_up_required}
            onClick={handleFollowUpRequiredClick}
          />
        </div>
        <textarea
          className="consultation-textarea"
          name="description"
          value={outcomeForm.description}
          onChange={e => {
            setOutcomeForm(prev => ({...prev, description: e.target.value}));
            if (showValidation) setShowValidation(false);
          }}
          placeholder="Write any further actions here *"
        />
        {showValidation && isDescriptionEmpty && (
          <div style={{color: 'red', marginTop: 4}}>
            Description is required.
          </div>
        )}
      </div>
      <div className="end-consultation-footer">
        <FrontdeskButton
          title={isPending ? 'Submitting...' : 'Confirm'}
          loading={isPending}
          disabled={isPending || disableSubmit || isDescriptionEmpty}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};

export default EndConsultationComponent;
